import { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";
import { prod } from "@/lib/prodApi";

const ROLE_ORDER = ["interviewer", "vale", "ward", "marsh", "cale"];

function Sample({ a }) {
  const src = a.audio_url && a.audio_url.startsWith("/api") ? mediaUrl(a.audio_url) : a.audio_url;
  return (
    <div className="panel p-5" data-testid={`audition-${a.id}`}>
      <div className="flex items-baseline gap-3">
        <span className="tag tag-blue">{a.kind === "library" ? "Library" : a.kind === "designed" ? `Designed ${a.option || ""}` : `Option ${a.option}`}</span>
        <span className="text-xl font-bold">{a.voice_name}</span>
        {a.duration_sec && <span className="ml-auto text-[15px] text-[#505a5f]">{a.duration_sec}s</span>}
      </div>
      <audio controls preload="none" src={src} className="w-full mt-4" data-testid={`audition-audio-${a.id}`} />
      <details className="mt-3">
        <summary className="cursor-pointer link text-[16px]">Directed text</summary>
        <p className="mt-2 whitespace-pre-line text-[16px]">{a.text}</p>
      </details>
    </div>
  );
}

export default function Auditions() {
  const [rows, setRows] = useState(null);
  useEffect(() => { prod.get("/auditions").then((r) => setRows(r.data)); }, []);
  if (!rows) return <p className="text-lg py-8">Loading auditions…</p>;
  const designed = rows.filter((r) => r.kind === "designed");
  const older = rows.filter((r) => r.kind !== "designed");
  return (
    <div data-testid="auditions-page">
      <h2 className="text-4xl font-black">Auditions</h2>
      <p className="text-lg text-[#505a5f] mt-2 max-w-3xl">ElevenLabs Voice Design previews (eleven_ttv_v3), three per role. The picked voices are saved as "SPORE – …" in the voice library.</p>
      {ROLE_ORDER.map((role) => {
        const opts = designed.filter((a) => a.role === role);
        if (!opts.length) return null;
        return (
          <section key={role} className="mt-8" data-testid={`designed-role-${role}`}>
            <h3 className="text-2xl font-black capitalize">{role}</h3>
            <div className="grid grid-cols-3 gap-6 mt-3">{opts.map((a) => <Sample key={a.id} a={a} />)}</div>
          </section>
        );
      })}
      {older.length > 0 && (
        <details className="mt-12">
          <summary className="cursor-pointer text-2xl font-black link">Earlier auditions (rejected) · existing account voices</summary>
          <div className="grid grid-cols-2 gap-6 mt-6">{older.map((a) => <Sample key={a.id} a={a} />)}</div>
        </details>
      )}
    </div>
  );
}
